import React, { useEffect, useState, useMemo } from 'react'

import { MultiDropDownSelect } from '../../../../../components/dashboard/TalentPool/DropdownSelect'

import SkillLevelSelector from './SkillLevelSelector'

import axiosInstance from '../../../../../services/config/AxiosIntance'

const ApplicantSkills = ({ skill, onChange, fieldErrors }) => {
  const [professionalHeadlineList, setProfessionalHeadlineList] = useState([])
  const [softSkillList, setSoftSkillList] = useState([])

  useEffect(() => {
    Promise.all([
      axiosInstance.get('/professional-headlines?withSkills=true'),
      axiosInstance.get('/skills'),
    ])
      .then(([headlinesRes, skillsRes]) => {
        const professionalHeadlinesData = headlinesRes?.data?.resp || []
        const formattedHeadlines = professionalHeadlinesData.map(
          (headline) => ({
            value: headline.id,
            label: headline.professional_headline,
          })
        )
        setProfessionalHeadlineList(formattedHeadlines)

        const softSkillsData = skillsRes?.data?.data?.softSkills
        const formattedSoftSkills = softSkillsData?.map((skill) => ({
          value: skill,
          label: skill,
        }))
        setSoftSkillList(formattedSoftSkills)
      })
      .catch((error) => {
        console.error('Error fetching data:', error)
      })
  }, [])

  const professionalHeadlineIds = useMemo(
    () =>
      JSON.stringify(
        skill?.professionalHeadlines?.map((headlines) => headlines.value) || [
          professionalHeadlineList[0]?.value,
        ]
      ),
    [skill?.professionalHeadlines]
  )

  return (
    <>
      <MultiDropDownSelect
        setSelectedOption={(e) => onChange('softSkills', e)}
        selectedOption={skill?.softSkills}
        options={softSkillList}
        title="Soft Skills"
        placeholder="Select Soft Skills"
        className={fieldErrors?.softSkills ? 'has__error' : ''}
        errorMessage={fieldErrors?.softSkills}
      />

      <MultiDropDownSelect
        setSelectedOption={(e) => onChange('professionalHeadlines', e)}
        selectedOption={skill?.professionalHeadlines}
        options={professionalHeadlineList}
        title="Professional Headlines"
        placeholder="Select Professional Headlines"
        className={fieldErrors?.professionalHeadlines ? 'has__error' : ''}
        errorMessage={fieldErrors?.professionalHeadlines}
      />

      <SkillLevelSelector
        professionalHeadlineIds={professionalHeadlineIds}
        onChange={onChange}
        technicalSkills={skill?.technicalSkills}
        className={fieldErrors?.technicalSkills ? 'has__error' : ''}
        errorMessage={fieldErrors?.technicalSkills}
      />
    </>
  )
}

export default ApplicantSkills
